// HM / HR BP seçici seçenekleri için saf yardımcılar (müşteri geri bildirimi
// 2026-08). Henüz işe BAŞLAMAMIŞ (EmploymentDate ileri tarihli, preboarding'deki)
// kişiler listeden ÇIKARILMAZ — onboarding/preboarding'deki kişi çalışandır ve
// ileri-tarihli yöneticiye hazırlık senaryosu meşrudur — ama başlangıç tarihi
// etiketiyle işaretlenir; isim çakışmasında da ayırt edici olur.

export function employeeDisplayName(e) {
  if (!e) return '';
  const joined = `${e.firstName || ''} ${e.lastName || ''}`.trim();
  return joined || e.fullName || e.corporateEmail || e.id || '';
}

// İşe başlangıcı GÜN bazında bugünden sonraysa Date döner; bugün başlayan,
// geçmiş, eksik veya bozuk tarihte null (etiket gösterilmez).
export function futureStartDate(e, now = new Date()) {
  if (!e?.employmentDate) return null;
  const d = new Date(e.employmentDate);
  if (Number.isNaN(d.getTime())) return null;
  const day = (x) => Date.UTC(x.getUTCFullYear(), x.getUTCMonth(), x.getUTCDate());
  return day(d) > day(now) ? d : null;
}
